import React, { useEffect } from "react";

import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import useTransmissionReportLog from "./useTransmissionReportLog";
import { setSelectedUser } from "app/store/userActivityLog/slice/userActivityLogSlice";

const TransmissionReportLogUserForm = () => {
  const { fetchUsers, dispatch, userList, modifiedUserList } =
    useTransmissionReportLog();

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <div>
      <Autocomplete
        disabled={!userList?.length}
        id="combo-box-demo"
        options={modifiedUserList}
        fullWidth={true}
        onChange={(_, newValue) => {
          dispatch(setSelectedUser(newValue));
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Select a user"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {!userList?.length ? <CircularProgress size={20} /> : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </div>
  );
};

export default TransmissionReportLogUserForm;
